import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';


const TeachersDay9to122026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay9to12/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay9to12/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay9to12/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay9to12/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay9to12/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay9to12/6.webp`;

    const photos = [
  
        {
            src: p1,
            source: p1,
            rows: 2,
            cols: 2,
        }, 
        {
            src: p2,
            source: p2,
            rows: 2,
            cols: 2,
        }, {
            src: p3,
            source: p3,
            rows: 2,
            cols: 2,
        }, {
            src: p4,
            source: p4,
            rows: 2,
            cols: 2,
        }, {
            src: p5,
            source: p5,
            rows: 2,
            cols: 2,
        }, {
            src: p6,
            source: p6,
            rows: 2,
            cols: 2,
        }
 
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                          
                            <Box >
                                <Typography variant='h4' align='center'>
                                Teacher’s Day
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                Classes: 9-12          Date:4 September 2026
                                </Typography>

                                <br />
                                                    <Typography variant={'subtitle1'} align={'justify'}>
Students of Classes 9 to 12, under the initiative of the Student Council, organised a memorable Teachers’ Day celebration at National Public School, Yeshwanthpur, on Friday 4 September. The event was a heartfelt tribute to the dedication, commitment and invaluable 
contribution of teachers in shaping young minds and nurturing responsible citizens.
                                                        <br></br>
The celebration began on a warm and festive note, with students expressing their gratitude through a thoughtfully curated programme. A series of engaging performances — including music, dance and entertaining presentations which beautifully brought alive the spirit of appreciation and admiration for the teaching fraternity. A special highlight of the celebration was a friendly throwball match between the teachers and students,
 which added an exciting sporting dimension to the festivities.
                                                        <br></br>
The event concluded on a joyful and appreciative note, with students conveying the timeless message that a teacher’s influence extends far beyond the classroom. The combination of 
heartfelt performances and the lively throwball match made the celebration truly special, leaving the teachers and students with cherished memories.
                                                        <br></br>

                                                    </Typography>
                            </Box>
                             <Typography
                                                            variant={'h6'}
                                                            color={'primary'}
                                                            align={'center'}
                                                            fontWeight={'normal'}
                                                        ><br />
“A great teacher doesn’t just teach; they inspire, empower and transform lives.”                                                            <br />
        
                                                        </Typography>
                             <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default TeachersDay9to122026;
